/**
 * Decide o evento de carrinho a partir da mudança de quantidade (CA-3, CA-4, CA-4.1).
 *
 * `setShoppingItem` recebe quantidade absoluta, então o delta sai da comparação
 * com o que o item já tinha no carrinho. Mudança automática — limpeza após o
 * pedido e no logout — não é ação do usuário e não gera evento.
 *
 * @returns {{name: string, quantity: number, item: object}|null}
 */
export function cartChangeEvent(
  { item, previousQuantity = 0, nextQuantity = 0, automatic = false } = {},
) {
  if (automatic) {
    return null;
  }
  const delta = (Number(nextQuantity) || 0) - (Number(previousQuantity) || 0);
  if (!delta) {
    return null;
  }
  return {
    name: delta > 0 ? "add_to_cart" : "remove_from_cart",
    quantity: Math.abs(delta),
    item,
  };
}

/**
 * Decide se a busca gera `search` para o termo informado (CA-11).
 *
 * Aqui só mora o corte por termo repetido. Qual termo é o consolidado é
 * decisão de `createSearchTracker`, que espera a digitação parar — a busca
 * faz `router.replace` a cada 400ms do debounce, e comparar fragmento a
 * fragmento faria sobrar justamente o primeiro pedaço digitado.
 */
export function searchEvent(term, lastTerm) {
  const atual = String(term ?? "").trim();

  if (!atual || atual === String(lastTerm ?? "").trim()) {
    return null;
  }

  return { name: "search", params: { search_term: atual } };
}

/**
 * Decide e monta o `page_view` da troca de rota (CA-12).
 *
 * Não conta a navegação inicial (o snippet já registra o carregamento do
 * documento) nem a troca de query dentro da mesma rota, que a busca dispara
 * a cada debounce.
 *
 * @returns {{page_location: string, page_title: string}|null}
 */
export function routePageView(to, from, options = {}) {
  const { first = false, origin = "", title = "" } = options;

  if (first || !to || !from || to.path === from.path) {
    return null;
  }

  const tituloResolvido = /^carregando/i.test(String(title).trim())
    ? ""
    : title;

  return {
    page_location: `${origin}#${to.fullPath}`,
    page_title: to.meta?.title ?? tituloResolvido,
  };
}
